module.exports = __webpack_public_path__ + "static/pic01@4x-ac11a46a9dcb3294d68099a8036f0a37.jpg";